import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function SitePage() {
  const { id } = useParams();
  const [site, setSite] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.getSite(id).then(setSite).catch(() => setErr(true)); }, [id]);

  if (err) return <div className="flex min-h-screen items-center justify-center text-muted-foreground">الموقع غير موجود.</div>;
  if (!site) return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-cyan" /></div>;
  return (
    <div className="h-screen w-screen overflow-hidden bg-white">
      <iframe title={site.title} srcDoc={site.html} className="h-full w-full border-0 bg-white" />
    </div>
  );
}
